var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"registration-header"},[_c('div',{staticClass:"registration-header__inner"},[_c('LogoLink'),_vm._v(" "),_c('div',{staticClass:"registration-header__login-button"},[_c('BaseGhostButtonLink',{staticClass:"--s",attrs:{"href":"/signin/","target":"_blank"}},[_vm._v("\n        войти в мтс линк\n      ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }